import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/storeTs/modules/AuthModule";
import BodyModule from "@/storeTs/modules/BodyModule";
import BreadcrumbsModule from "@/storeTs/modules/BreadcrumbsModule";
import ConfigModule from "@/storeTs/modules/ConfigModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
  },
});

export default store;
